module.exports = __webpack_public_path__ + "static/media/phone.dd4ad77e.svg";